import 'angular-one-render-react-component';

/* istanbul ignore next */
if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('checkout');
}
angular.module('checkout', [
    'ngRoute',
    'pascalprecht.translate',
    'RcmLoading',
    'RcmJsLib',
    'rcmApiLib',
    'RcmDialog',
    'testMode',
    'angularOneRenderReactComponent',
]);
